import { Requester } from './Requester';
import { ISurveyFull } from '../types';

export const PatchSurvey = async ({
    data,
    furthestStep,
    surveyId
}: {
    data: Record<string, any>;
    furthestStep: number;
    surveyId?: string;
}): Promise<ISurveyFull | null> => {
    try {
        const response = await Requester<ISurveyFull | null>({
            path: `surveys/${surveyId}`,
            method: 'PATCH',
            payload: {
                keyed: data,
                stepCompletion: furthestStep
            }
        });

        return response && Object.hasOwn(response, '_id') ? (response as ISurveyFull) : null;
    } catch (e) {
        console.error('Patch survey request failed');
        return Promise.reject(e);
    }
};
